import script from "./QuantityPanelV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuantityPanelV2.vue?vue&type=script&setup=true&lang=ts"

import "./QuantityPanelV2.vue?vue&type=style&index=0&id=6c944c60&lang=scss"

const __exports__ = script;

export default __exports__